import { cancellationReasons } from 'data/mock-data';

const mock = () => ({
  data: {
    cancellationReasons,
  },
});

export default mock;
